import { Card, Stack, Badge, Button, Group } from "@mantine/core";
import { IconSend, IconX } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { useInfiniteResource, useAction } from "../../../shared/api";
import { PageHeader, MoneyDisplay, EmptyState, InfiniteTable } from "../../../shared/ui";

const STATUS_COLOR: Record<string, string> = {
  DRAFT: "gray", QUEUED: "blue", APPROVED: "green", REJECTED: "red", CANCELLED: "orange",
};

export function InvoicesPage() {
  // invoices viewset'inde search_fields yok — arama eklenmiyor.
  const {
    items: list,
    total,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteResource<any>("invoices");
  const sendGib = useAction("invoices", "send-gib");
  const cancel = useAction("invoices", "cancel");

  return (
    <Stack gap="md">
      <PageHeader title="E-Fatura" subtitle={`${total} fatura`} />
      <Card padding="sm" radius="md" withBorder>
        <InfiniteTable
          rows={list}
          rowKey={(i) => i.id}
          isLoading={isLoading}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={fetchNextPage}
          emptyContent={<EmptyState title="Fatura yok" />}
          columns={[
            { header: "Fatura No", render: (i) => <span style={{ fontWeight: 600 }}>{i.invoice_number}</span> },
            { header: "Tip", render: (i) => <Badge variant="light">{i.invoice_type}</Badge> },
            { header: "Tarih", render: (i) => new Date(i.invoice_date).toLocaleDateString("tr-TR") },
            { header: "GİB Durum", render: (i) => <Badge color={STATUS_COLOR[i.status]}>{i.status}</Badge> },
            {
              header: "UUID",
              render: (i) => (
                <span style={{ fontSize: 10, fontFamily: "monospace" }}>{i.gib_uuid?.substring(0, 8) || "-"}</span>
              ),
            },
            { header: "Toplam", align: "right", render: (i) => <MoneyDisplay minor={i.total_minor} fw={600} /> },
            {
              header: "İşlem",
              render: (i) => (
                <Group gap="xs">
                  {(i.status === "DRAFT" || i.status === "REJECTED") && (
                    <Button size="xs" leftSection={<IconSend size={14} />} onClick={async () => {
                      try { await sendGib.mutateAsync({ id: i.id }); notifications.show({ message: "GİB'e gönderildi", color: "green" }); }
                      catch (e: any) { notifications.show({ message: e?.response?.data?.detail || "Hata", color: "red" }); }
                    }}>Gönder</Button>
                  )}
                  {i.status === "APPROVED" && (
                    <Button size="xs" color="red" variant="light" leftSection={<IconX size={14} />} onClick={() => cancel.mutateAsync({ id: i.id, reason: "İptal" })}>İptal</Button>
                  )}
                </Group>
              ),
            },
          ]}
        />
      </Card>
    </Stack>
  );
}
